module.exports = __webpack_public_path__ + "static/media/page-bg-bottom.ec613ada.png";